
// Função para converter horas HH:MM para decimal
export const convertHoursToDecimal = (timeString: string): number => {
  if (!timeString) return 0;
  
  // Se já é um número decimal, retorna como está
  if (!timeString.includes(':')) {
    const parsed = parseFloat(timeString.replace(',', '.'));
    return isNaN(parsed) ? 0 : parsed;
  }
  
  const [hours, minutes] = timeString.split(':').map(Number);
  const hoursDecimal = hours + (minutes / 60);
  
  return hoursDecimal;
};
